import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ResourceManagementPage from "@/pages/admin/ResourceManagementPage";

export const Route = createFileRoute("/_admin/admin/resources")({
  head: () => pageHead("Admin · Resources", "AKIVA admin · resources portal.", "/admin/resources", true),
  component: ResourceManagementPage,
});
